import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';

/**
 * LandingPage - Public home page (not behind login)
 * Required for Google OAuth verification
 */
export function LandingPage() {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(/landingpagebackground.jpg)' }}
      >
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-forest-950/80 via-forest-900/70 to-forest-950/90" />
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Header */}
        <header className="px-6 py-4 flex items-center justify-between max-w-6xl mx-auto w-full">
          <div className="flex items-center gap-3">
            <img
              src="/logo.png"
              alt="The Wright Gardner Logo"
              className="h-12 w-auto"
            />
          </div>
          <Link to="/login">
            <Button variant="primary" size="sm">Sign In</Button>
          </Link>
        </header>

        {/* Hero */}
        <main className="flex-1 flex flex-col items-center justify-center px-6 py-16 text-center">
          {/* Logo */}
          <img
            src="/logo.png"
            alt="The Wright Gardner"
            className="h-32 md:h-40 w-auto mb-8 drop-shadow-2xl"
          />

          <h1 className="font-display text-4xl md:text-6xl font-bold text-white mb-4 drop-shadow-lg">
            The Wright Gardner
          </h1>

          <p className="text-xl md:text-2xl text-forest-100 mb-2 font-display font-medium drop-shadow-md">
            Gen3 App
          </p>

          <p className="text-lg md:text-xl text-forest-200 mb-10 max-w-xl mx-auto drop-shadow-md">
            Let us Handle The Plants
          </p>

          <Link to="/login">
            <Button variant="primary" size="lg" className="shadow-glow-lg">
              Get Started
            </Button>
          </Link>
        </main>

        {/* Footer */}
        <footer className="px-6 py-8 border-t border-white/10">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-forest-300 text-sm">
              © {new Date().getFullYear()} The Wright Gardner. All rights reserved.
            </p>
            <nav className="flex gap-6">
              <Link to="/privacy" className="text-forest-300 hover:text-white text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-forest-300 hover:text-white text-sm transition-colors">
                Terms of Service
              </Link>
            </nav>
          </div>
        </footer>
      </div>
    </div>
  );
}
